import React, { useEffect, useState } from "react";
import api from "../axiosConfig"; // tu instancia de axios
import "bootstrap/dist/css/bootstrap.min.css";

const RankingTiposPagos = () => {
  const [ranking, setRanking] = useState([]);

  useEffect(() => {
    const fetchRanking = async () => {
      try {
        const response = await api.get("/reportes/ranking");
        setRanking(response.data.data);
      } catch (error) {
        console.error("Error al obtener ranking:", error);
      }
    };

    fetchRanking();
  }, []);

  const top5 = ranking.slice(0, 5);

  return (
    <div className="mb-3 d-flex justify-content-center">
      <div className="card shadow-lg border-0 rounded-3" style={{ width: "100%", maxWidth: "400px" }}>
        {/* Encabezado con degradado */}
        <div
          style={{
            background: "linear-gradient(90deg, #4e73df, #1cc88a)",
            padding: "10px 15px",
            borderTopLeftRadius: "0.5rem",
            borderTopRightRadius: "0.5rem",
          }}
        >
          <h6 className="mb-0 text-center fw-bold text-white">
            Top 5 Tipos de Pago
          </h6>
        </div>

        {/* Lista */}
        <ul className="list-group list-group-flush">
          {top5.map((item, idx) => (
            <li
              key={idx}
              className="list-group-item d-flex justify-content-between align-items-center"
              style={{ fontSize: "0.95rem", transition: "background 0.3s" }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background = "#f8f9fc")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background = "white")
              }
            >
              <span className="fw-semibold">
                {idx + 1}. {item.tipo_pago}
                <div style={{ fontSize: "0.8rem", color: "#555" }}>
                  {item.total_transacciones} transacciones
                </div>
              </span>

              <span className="badge bg-primary rounded-pill px-3 py-2">
                ${item.total_monto}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default RankingTiposPagos;